export function getFormattedDate(
  value: string | null | undefined,
  locale: string,
) {
  if (!value) {
    return '-';
  }

  return new Date(value).toLocaleString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
